<template>
  <b-modal
    id="select-strategy-import-from-idml"
    title="Import IDML"
    centered
    size="lg"
    :ok-disabled="isLoading || (!selectedLayout && !newLayoutName.trim())"
    @ok="handleImport"
    @hide="reset"
  >
    <Multiselect
      v-model="selectedLayout"
      :options="layouts"
      :loading="isLoading"
      searchable
      :multiple="false"
      :custom-label="layoutLabel"
      track-by="id"
      class="mb-3"
      placeholder="Add to existing layout (optional)"
      @search-change="searchLayouts"
    >
      <template
        v-if="layouts.length < layoutsTotalCount"
        #afterList
      >
        <div class="text-center p-2">
          <b-button
            :disabled="isLoading"
            variant="outline-primary"
            @click.stop="getLayouts"
          >
            Load More
          </b-button>
        </div>
      </template>
    </Multiselect>
    <b-form-group
      v-if="!selectedLayout"
      label="New layout name"
    >
      <b-form-input v-model="newLayoutName" />
    </b-form-group>
  </b-modal>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import LayoutAPI from '@frontend/services/api/layout';
import {ACTION_IMPORT_FROM_PRESELECTED_IDML} from '@frontend/group/modules/import-template-from-idml';
import {
  IDML_IMPORT_EVENTS,
  importIDMLEventBroker
} from '@frontend/group/modules/import-template-from-idml/event-broker';

let searchTimer;

export default {
  name: 'SelectStrategyImportFromIDML',
  components: {Multiselect},
  data() {
    return {
      settings: null,
      selectedLayout: null,
      layouts: [],
      layoutsTotalCount: 0,
      isLoading: false,
      page: 1,
      search: null,
      newLayoutName: '',
    };
  },
  mounted() {
    importIDMLEventBroker.on(IDML_IMPORT_EVENTS.SELECT_LAYOUT, this.init, true);
  },
  beforeDestroy() {
    importIDMLEventBroker.off(IDML_IMPORT_EVENTS.SELECT_LAYOUT, this.init);
  },
  methods: {
    init({settings}) {
      this.settings = settings;
      this.newLayoutName = settings.preselectedFiles[0]?.name || '';
      this.getLayouts();
      this.$bvModal.show('select-strategy-import-from-idml');
    },
    async handleImport(event) {
      event.preventDefault();
      if (!this.settings?.preselectedFiles?.length) return;
      this.isLoading = true;
      localStorage.setItem(ACTION_IMPORT_FROM_PRESELECTED_IDML, JSON.stringify({
        files: this.settings.preselectedFiles,
        fileBrowserUrl: window.location.href,
      }));

      if (this.selectedLayout) {
        window.location.href = `/banner/${this.selectedLayout.customer_id}/group/${this.selectedLayout.id}/show?action=${ACTION_IMPORT_FROM_PRESELECTED_IDML}`;
        return;
      }

      try {
        const {data} = await axios.post('/banner/0/group/create-layout-from-psd', {
          file: {name: this.newLayoutName},
        });
        window.location.href = `/banner/${data.customer_id}/group/${data.layout_id}/show?action=${ACTION_IMPORT_FROM_PRESELECTED_IDML}`;
      } finally {
        this.isLoading = false;
      }
    },
    async getLayouts() {
      this.isLoading = true;
      try {
        const {data: {layouts, totalCount}} = await LayoutAPI.getLayouts({
          params: {search: this.search, page: this.page, limit: 20},
        });
        this.layouts = this.layouts.concat(layouts);
        this.layoutsTotalCount = totalCount;
        this.page++;
      } finally {
        this.isLoading = false;
      }
    },
    searchLayouts(search) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        this.page = 1;
        this.search = search;
        this.layouts = [];
        this.getLayouts();
      }, 500);
    },
    reset() {
      clearTimeout(searchTimer);
      this.selectedLayout = null;
      this.layouts = [];
      this.layoutsTotalCount = 0;
      this.page = 1;
      this.search = null;
      this.isLoading = false;
    },
    layoutLabel({id, name}) {
      return `${id} - ${name}`;
    },
  },
};
</script>
